import React from "react";
import {Delete, translate} from "admin-on-rest";
import PartnerDataList from "./PartnerDataList";
import PartnerEditForm from "./PartnerEditForm";
import PartnerCreateForm from "./PartnerCreateForm";

///////////////////// LIST ALL PARTNERS /////////////////////
export const PartnerList = props => <PartnerDataList {...props} />;

///////////////////// UPDATE PARTNER /////////////////////
export const PartnerEdit = props => <PartnerEditForm {...props} />;

///////////////////// CREATE NEW PARTNER /////////////////////
export const PartnerCreate = props => <PartnerCreateForm {...props} />;

///////////////////// DELETE PARTNER /////////////////////
const PartnerDeleteTitleBase = ({record, translate}) => (
  <span>
    {translate("aor.action.delete")}&nbsp;
    {record && <img src={`${record.avatar}?size=25x25`} width="25" alt="" />}
    {record && `${record.first_name} ${record.last_name}`}
  </span>
);

const PartnerDeleteTitle = translate(PartnerDeleteTitleBase);

export const PartnerDelete = props => (
  <Delete {...props} title={<PartnerDeleteTitle />} />
);



// WEBPACK FOOTER //
// ./src/containers/CRM/Partners/index.js